<!-- Breadcrumb -->
<ol class="breadcrumb page-breadcrumb">
  <li class="breadcrumb-item">
    <a href="javascript:void(0);" [routerLink]="['/admin/home']">Home</a>
  </li>
  <li class="breadcrumb-item active">Relatório de aulas confirmadas</li>
  <li class="position-absolute pos-top pos-right d-none d-sm-block">
    <span class="js-get-date"></span>
  </li>
</ol>

<!-- ==================== FILTRO ==================== -->
<div class="row">
  <div class="col-md-12">
    <div class="panel" id="panel-filter">
      <div class="panel-hdr">
        <h2><i class="fal fa-filter mr-1"></i> Filtro</h2>
      </div>
      <div class="panel-container show">
        <div class="panel-content">
          <!-- Linha 1: Professor(a) -->
          <div class="form-row">
            <div class="col-md-12 mb-3">
              <span
                role="status"
                aria-hidden="true"
                class="spinner-border spinner-border-sm pull-left mr-2 text-primary"
                *ngIf="flagSearchTeacher"
              ></span>
              <span class="text-primary pull-left" *ngIf="flagSearchTeacher"
                >Carregando professores</span
              >
              <label class="form-label" for="teacherId"
                >Professor(a) <span class="text-danger">*</span></label
              >
              <div class="ng-autocomplete w-100">
                <ng-autocomplete
                  [data]="teacherDataList"
                  searchKeyword="name"
                  placeholder="Digite o nome do(a) professor(a)"
                  (selected)="setTeacher($event)"
                  [itemTemplate]="itemTemplate"
                  [notFoundTemplate]="notFoundTemplate"
                >
                </ng-autocomplete>
                <ng-template #itemTemplate let-item>
                  <a [innerHTML]="item.name"></a>
                </ng-template>
                <ng-template #notFoundTemplate let-notFound>
                  <div [innerHTML]="notFound"></div>
                </ng-template>
              </div>
            </div>
          </div>
          <!-- Linha 2: Turma + Datas + Atalhos de período -->
          <div class="form-row align-items-end">
            <div class="col-md-3 mb-3">
              <label class="form-label" for="courseId">Turma</label>
              <div class="ng-autocomplete w-100">
                <ng-autocomplete
                  [data]="courseDataList"
                  searchKeyword="name"
                  placeholder="Todas as turmas"
                  (selected)="setCourse($event)"
                  [itemTemplate]="itemTemplateCourse"
                  [notFoundTemplate]="notFoundTemplateCourse"
                >
                </ng-autocomplete>
                <ng-template #itemTemplateCourse let-item>
                  <a [innerHTML]="item.name"></a>
                </ng-template>
                <ng-template #notFoundTemplateCourse let-notFound>
                  <div [innerHTML]="notFound"></div>
                </ng-template>
              </div>
            </div>
            <div class="col-md-2 mb-3">
              <label class="form-label" for="startDate">Data inicial</label>
              <input
                type="date"
                id="startDate"
                [(ngModel)]="startDate"
                class="form-control"
                placeholder="Data inicial"
                (change)="setStartDate($event)"
              />
            </div>
            <div class="col-md-2 mb-3">
              <label class="form-label" for="endDate">Data final</label>
              <input
                type="date"
                id="endDate"
                [(ngModel)]="endDate"
                class="form-control"
                placeholder="Data final"
                (change)="setEndDate($event)"
              />
            </div>
            <div class="col-md-5 mb-3">
              <label class="form-label d-block">Atalhos de período</label>
              <div class="btn-group btn-group-sm" role="group">
                <button
                  type="button"
                  class="btn btn-outline-primary"
                  [class.active]="activePeriodShortcut === 'currentMonth'"
                  (click)="setPeriod('currentMonth')"
                >
                  <i class="fal fa-calendar-alt mr-1"></i> Este mês
                </button>
                <button
                  type="button"
                  class="btn btn-outline-primary"
                  [class.active]="activePeriodShortcut === 'lastMonth'"
                  (click)="setPeriod('lastMonth')"
                >
                  <i class="fal fa-calendar-minus mr-1"></i> Mês anterior
                </button>
                <button
                  type="button"
                  class="btn btn-outline-primary"
                  [class.active]="activePeriodShortcut === 'last30'"
                  (click)="setPeriod('last30')"
                >
                  <i class="fal fa-calendar-week mr-1"></i> Últimos 30 dias
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          class="panel-content border-faded border-left-0 border-right-0 border-bottom-0 d-flex flex-row align-items-center"
        >
          <button
            class="btn btn-outline-secondary"
            type="button"
            (click)="clearFilters()"
          >
            <i class="fal fa-eraser mr-1"></i> Limpar
          </button>
          <button
            class="btn btn-primary ml-auto"
            type="button"
            [disabled]="flagFiltering"
            (click)="getConfirmedClasses(null)"
          >
            <span
              *ngIf="flagFiltering"
              class="spinner-border spinner-border-sm mr-1"
            ></span>
            <i class="fal fa-search mr-1" *ngIf="!flagFiltering"></i> Filtrar
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- ==================== DADOS DO PROFESSOR(A) ==================== -->
<div class="row" *ngIf="teacherId > 0">
  <div class="col-md-12">
    <div class="panel" id="panel-teacher-info">
      <div class="panel-hdr">
        <h2><i class="fal fa-user-tie mr-1"></i> Dados do(a) Professor(a)</h2>
        <div class="panel-toolbar">
          <button
            class="btn btn-panel"
            data-action="panel-collapse"
            data-toggle="tooltip"
            data-offset="0,10"
            data-original-title="Expandir / Recolher"
          >
            <i class="fal fa-minus"></i>
          </button>
        </div>
      </div>
      <div class="panel-container show">
        <div class="panel-content">
          <!-- Dados Pessoais -->
          <div class="form-row">
            <div class="col-md-4">
              <div class="form-group">
                <label class="form-label text-muted" for="teacherName"
                  ><i class="fal fa-user mr-1"></i>Nome</label
                >
                <input
                  type="text"
                  id="teacherName"
                  class="form-control"
                  disabled
                  [value]="teacherData?.name"
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label class="form-label text-muted" for="teacherEmail"
                  ><i class="fal fa-envelope mr-1"></i>E-mail</label
                >
                <input
                  type="text"
                  id="teacherEmail"
                  class="form-control"
                  disabled
                  [value]="teacherData?.email"
                />
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group">
                <label class="form-label text-muted" for="teacherPhone"
                  ><i class="fal fa-phone mr-1"></i>Telefone</label
                >
                <input
                  type="text"
                  id="teacherPhone"
                  class="form-control"
                  disabled
                  [value]="teacherData?.phone"
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label class="form-label text-muted" for="teacherHourlyRate"
                  ><i class="fal fa-dollar-sign mr-1"></i>Valor/Hora</label
                >
                <input
                  id="teacherHourlyRate"
                  class="form-control fw-700 text-success"
                  disabled
                  [value]="teacherData?.formatHourlyRate"
                />
              </div>
            </div>
          </div>
          <!-- Dados Bancários (Accordion colapsável) -->
          <div class="accordion accordion-clean" id="accordionBankInfo">
            <div class="card">
              <div class="card-header" id="headingBankInfo">
                <a
                  href="javascript:void(0);"
                  class="card-title collapsed"
                  data-toggle="collapse"
                  data-target="#collapseBankInfo"
                  aria-expanded="false"
                  aria-controls="collapseBankInfo"
                >
                  <i class="fal fa-university mr-1 text-primary"></i>
                  Dados Bancários
                  <span class="ml-auto">
                    <span class="collapsed-reveal"
                      ><i class="fal fa-chevron-up fs-xl"></i
                    ></span>
                    <span class="collapsed-hidden"
                      ><i class="fal fa-chevron-down fs-xl"></i
                    ></span>
                  </span>
                </a>
              </div>
              <div
                id="collapseBankInfo"
                class="collapse"
                aria-labelledby="headingBankInfo"
                data-parent="#accordionBankInfo"
              >
                <div class="card-body p-3">
                  <div class="form-row">
                    <div class="col-md-3">
                      <div class="form-group">
                        <label class="form-label text-muted" for="teacherAgency"
                          >Agência</label
                        >
                        <input
                          type="text"
                          id="teacherAgency"
                          class="form-control"
                          disabled
                          [value]="teacherData?.agency"
                        />
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="form-group">
                        <label
                          class="form-label text-muted"
                          for="teacherAccount"
                          >Conta</label
                        >
                        <input
                          type="text"
                          id="teacherAccount"
                          class="form-control"
                          disabled
                          [value]="teacherData?.account"
                        />
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="form-group">
                        <label class="form-label text-muted" for="teacherPix"
                          >Pix</label
                        >
                        <input
                          type="text"
                          id="teacherPix"
                          class="form-control"
                          disabled
                          [value]="teacherData?.pix"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- ==================== RESULTADO ==================== -->
<div class="row">
  <div class="col-md-12">
    <div class="panel" id="panel-result">
      <div class="panel-container show">
        <div class="panel-content">
          <!-- Estado vazio / instrução -->
          <div *ngIf="!showTable && !flagFiltering" class="text-center py-5">
            <i class="fal fa-clipboard-list fa-3x text-muted mb-3 d-block"></i>
            <p class="text-muted fs-lg">{{ returnMessage }}</p>
          </div>

          <!-- Resultado com dados -->
          <div *ngIf="showTable">
            <!-- KPI Cards - Financeiro (destaque) -->
            <h4 class="mb-3">
              <i class="fal fa-chart-bar mr-1 text-primary"></i>
              Consolidado do(a) Professor(a)
              <small class="text-muted"
                >Resumo financeiro e status das aulas no período</small
              >
            </h4>

            <div class="row kpi-row mb-4">
              <div class="col-md-4">
                <div
                  class="kpi-card kpi-card-done rounded p-3 text-white mb-g"
                  style="cursor: pointer"
                  (click)="getConfirmedClasses(1)"
                >
                  <div class="kpi-icon">
                    <i class="fal fa-check-circle"></i>
                  </div>
                  <div class="kpi-content">
                    <span class="kpi-value">{{
                      confirmedClassesSyntheticGroup?.countDone
                    }}</span>
                    <span class="kpi-label">Aulas Concluídas</span>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div
                  class="kpi-card kpi-card-hours rounded p-3 text-white mb-g"
                >
                  <div class="kpi-icon"><i class="fal fa-clock"></i></div>
                  <div class="kpi-content">
                    <span class="kpi-value"
                      >{{
                        confirmedClassesSyntheticGroup?.totalTimeDone
                      }}h</span
                    >
                    <span class="kpi-label">Total de Horas</span>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div
                  class="kpi-card kpi-card-money rounded p-3 text-white mb-g"
                >
                  <div class="kpi-icon"><i class="fal fa-dollar-sign"></i></div>
                  <div class="kpi-content">
                    <span class="kpi-value">{{
                      confirmedClassesSyntheticGroup?.totalAmountReceivable
                        | currency: "R$"
                    }}</span>
                    <span class="kpi-label"
                      >Total a Pagar
                      <span class="kpi-formula"
                        >({{ confirmedClassesSyntheticGroup?.countDone }} aulas
                        x
                        {{
                          confirmedClassesSyntheticGroup?.hourlyRate
                            | currency: "R$"
                        }}/h)</span
                      >
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Status Pills - Clicáveis -->
            <div class="status-pills-container mb-4">
              <label class="form-label d-block mb-2">
                <i class="fal fa-tags mr-1"></i> Filtrar por status
                <small class="text-muted ml-1">(clique para filtrar)</small>
              </label>
              <div class="d-flex flex-wrap">
                <button
                  type="button"
                  class="status-pill mr-2 mb-2"
                  [class.status-pill-active]="activeStatusFilter === null"
                  (click)="getConfirmedClasses(null)"
                >
                  <i class="fal fa-list mr-1"></i> Todas
                </button>
                <button
                  type="button"
                  class="status-pill status-pill-scheduled mr-2 mb-2"
                  [class.status-pill-active]="activeStatusFilter === 0"
                  (click)="getConfirmedClasses(0)"
                >
                  Agendadas
                  <span class="status-pill-count">{{
                    confirmedClassesSyntheticGroup?.countScheduled
                  }}</span>
                </button>
                <button
                  type="button"
                  class="status-pill status-pill-done mr-2 mb-2"
                  [class.status-pill-active]="activeStatusFilter === 1"
                  (click)="getConfirmedClasses(1)"
                >
                  Concluídas
                  <span class="status-pill-count">{{
                    confirmedClassesSyntheticGroup?.countDone
                  }}</span>
                </button>
                <button
                  type="button"
                  class="status-pill status-pill-delayed mr-2 mb-2"
                  [class.status-pill-active]="activeStatusFilter === 3"
                  (click)="getConfirmedClasses(3)"
                >
                  Atrasadas
                  <span class="status-pill-count">{{
                    confirmedClassesSyntheticGroup?.countDelayed
                  }}</span>
                </button>
                <button
                  type="button"
                  class="status-pill status-pill-changed-teacher mr-2 mb-2"
                  [class.status-pill-active]="activeStatusFilter === 4"
                  (click)="getConfirmedClasses(4)"
                >
                  Troca de Professor
                  <span class="status-pill-count">{{
                    confirmedClassesSyntheticGroup?.countChangedTeacher
                  }}</span>
                </button>
                <button
                  type="button"
                  class="status-pill status-pill-reschedule mr-2 mb-2"
                  [class.status-pill-active]="activeStatusFilter === 5"
                  (click)="getConfirmedClasses(5)"
                >
                  Reagendadas
                  <span class="status-pill-count">{{
                    confirmedClassesSyntheticGroup?.countReschedule
                  }}</span>
                </button>
                <button
                  type="button"
                  class="status-pill status-pill-partial mr-2 mb-2"
                  [class.status-pill-active]="activeStatusFilter === 6"
                  (click)="getConfirmedClasses(6)"
                >
                  Parcial
                  <span class="status-pill-count">{{
                    confirmedClassesSyntheticGroup?.countPartialConfirmed
                  }}</span>
                </button>
                <button
                  type="button"
                  class="status-pill status-pill-unchecked mr-2 mb-2"
                  [class.status-pill-active]="activeStatusFilter === 7"
                  (click)="getConfirmedClasses(7)"
                >
                  Desmarcadas
                  <span class="status-pill-count">{{
                    confirmedClassesSyntheticGroup?.countUnchecked
                  }}</span>
                </button>
                <button
                  type="button"
                  class="status-pill status-pill-holiday mr-2 mb-2"
                  [class.status-pill-active]="activeStatusFilter === 8"
                  (click)="getConfirmedClasses(8)"
                >
                  Feriado
                  <span class="status-pill-count">{{
                    confirmedClassesSyntheticGroup?.countHoliday
                  }}</span>
                </button>
              </div>
            </div>

            <hr />

            <!-- Tabela -->
            <managed-table
              [dataTitle]=""
              [rows]="confirmedClassesSyntheticData"
              [columns]="columns"
              [sorting]="true"
              [hasActions]="true"
              [ngTableFiltering]="false"
              [showFilterRow]="false"
              [previewEnable]="true"
              (previewClick)="
                showInfoConfirmedClasses($event, mdInfoConfirmedClasses)
              "
              [editEnable]="false"
              [deleteEnable]="false"
              [hasFilter]="false"
            >
            </managed-table>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ==================== MODAL DETALHES ==================== -->
  <div class="col-md-12">
    <ng-template #mdInfoConfirmedClasses let-c="close" let-d="dismiss">
      <div class="modal-header bg-primary">
        <h5 class="modal-title">
          <i class="fal fa-info-circle mr-1"></i> Detalhes da Aula
        </h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          (click)="dismissModal()"
        >
          <span aria-hidden="true"><i class="fal fa-times"></i></span>
        </button>
      </div>
      <div class="modal-body">
        <div class="panel-container show">
          <div class="panel-content p-0">
            <!-- Cabeçalho da aula -->
            <div class="d-flex align-items-center mb-3 p-3 bg-faded rounded">
              <i class="fal fa-user-tie fa-2x text-primary mr-3"></i>
              <div>
                <h5 class="mb-0 fw-700">
                  {{ previewSyntheticHeaderData?.teacherName }}
                </h5>
                <small class="text-muted"
                  >ID: {{ previewSyntheticHeaderData?.teacherId }}</small
                >
              </div>
            </div>

            <!-- Turmas -->
            <div class="mb-3 px-3">
              <label class="form-label text-muted fw-500 mb-1">Turmas:</label>
              <div
                [innerHTML]="previewSyntheticHeaderData?.designCoursesHtml"
              ></div>
            </div>

            <!-- Data e Horários - compacto -->
            <div class="d-flex flex-wrap px-3 mb-3">
              <div class="mr-4">
                <span class="fw-300 d-block text-muted fs-sm"
                  >Data da aula</span
                >
                <span
                  class="badge border border-primary text-primary fs-md p-2"
                >
                  <i class="fal fa-calendar mr-1"></i>
                  {{
                    previewSyntheticHeaderData?.expectedDate
                      | date: "dd/MM/yyyy"
                  }}
                </span>
              </div>
              <div class="mr-4">
                <span class="fw-300 d-block text-muted fs-sm">Início</span>
                <span
                  class="badge border border-primary text-primary fs-md p-2"
                >
                  <i class="fal fa-clock mr-1"></i>
                  {{ previewSyntheticHeaderData?.timeStart }}
                </span>
              </div>
              <div>
                <span class="fw-300 d-block text-muted fs-sm">Término</span>
                <span
                  class="badge border border-primary text-primary fs-md p-2"
                >
                  <i class="fal fa-clock mr-1"></i>
                  {{ previewSyntheticHeaderData?.timeEnd }}
                </span>
              </div>
            </div>

            <hr class="m-0" />

            <!-- Cards por turma -->
            <div class="p-3" *ngFor="let item of previewSyntheticData">
              <div class="card border mb-2 shadow-sm">
                <div
                  class="card-header d-flex align-items-center justify-content-between py-2"
                >
                  <span>
                    <i class="fal fa-users-class mr-1 text-primary"></i>
                    <strong class="fw-700"
                      >{{ item?.courseId }} | {{ item?.courseName }}</strong
                    >
                  </span>
                  <span class="d-flex align-items-center">
                    <span
                      class="badge badge-danger mr-2"
                      *ngIf="item?.classReplacement === true"
                    >
                      <i class="fal fa-exchange mr-1"></i> Substituição
                    </span>
                    <span
                      class="badge"
                      [ngClass]="getCourseTypeCss(item?.courseType)"
                    >
                      {{ getCourseTypeStr(item?.courseType) }}
                    </span>
                  </span>
                </div>

                <!-- Card por Aluno -->
                <div
                  class="card-body p-0"
                  *ngFor="
                    let child of item?.studentClassesCourseConfirmedSyntheticList;
                    let last = last
                  "
                >
                  <div class="p-3" [class.border-bottom]="!last">
                    <!-- Dados do aluno - compacto -->
                    <div class="d-flex align-items-start mb-2">
                      <i
                        class="fal fa-user-graduate fa-lg text-info mr-2 mt-1"
                      ></i>
                      <div class="flex-1">
                        <h5 class="mb-0 fw-700">{{ child?.student?.name }}</h5>
                        <small class="text-muted">
                          <i class="fal fa-envelope mr-1"></i
                          >{{ child?.student?.email }}
                          <span class="mx-2">|</span>
                          <i class="fal fa-phone mr-1"></i
                          >{{ child?.student?.phone }}
                        </small>
                      </div>
                    </div>

                    <!-- Dados financeiros e período do aluno - compacto em linha -->
                    <div class="d-flex flex-wrap mb-2 ml-4 pl-1">
                      <span
                        class="badge border border-faded text-muted mr-2 mb-1 p-1"
                      >
                        <i class="fal fa-receipt mr-1"></i>1ª parcela:
                        <strong>{{
                          child?.studentCourse?.installmentFirstDue
                            | date: "dd/MM/yyyy"
                        }}</strong>
                      </span>
                      <span
                        class="badge border border-faded text-muted mr-2 mb-1 p-1"
                      >
                        <i class="fal fa-calendar-day mr-1"></i>Vencimento: dia
                        <strong>{{ child?.studentCourse?.dueDay }}</strong>
                      </span>
                      <span
                        class="badge border border-faded text-muted mr-2 mb-1 p-1"
                      >
                        <i class="fal fa-play mr-1"></i>Início:
                        <strong>{{
                          child?.studentCourse?.startDate | date: "dd/MM/yyyy"
                        }}</strong>
                      </span>
                      <span
                        class="badge border border-faded text-muted mr-2 mb-1 p-1"
                      >
                        <i class="fal fa-stop mr-1"></i>Término:
                        <strong>{{
                          child?.studentCourse?.endDate | date: "dd/MM/yyyy"
                        }}</strong>
                      </span>
                      <span
                        class="badge border border-faded text-muted mr-2 mb-1 p-1"
                      >
                        <i class="fal fa-hourglass mr-1"></i>Duração:
                        <strong
                          >{{ child?.studentCourse?.monthTotal }} meses</strong
                        >
                      </span>
                    </div>

                    <!-- Status -->
                    <div class="ml-4 pl-1 mb-2">
                      <div
                        [innerHtml]="
                          designStatusClass(
                            child?.studentClassesCourse?.statusClass
                          )
                        "
                      ></div>
                    </div>

                    <!-- Confirmações -->
                    <div
                      class="ml-4 pl-1"
                      *ngIf="
                        child?.studentClassesCourse?.confirmedClassByStudent ||
                        child?.studentClassesCourse?.confirmedClassByTeacher
                      "
                    >
                      <!-- Confirmação do aluno -->
                      <div
                        class="d-flex align-items-center mb-1"
                        *ngIf="
                          child?.studentClassesCourse?.confirmedClassByStudent
                        "
                      >
                        <span
                          class="badge border border-success text-success p-1"
                        >
                          <i class="fal fa-check-circle mr-1"></i> Confirmado
                          pelo aluno
                          <span class="badge bg-success-50 text-dark ml-1">{{
                            child?.studentClassesCourse?.confirmedDateByStudent
                              | date: "dd/MM/yyyy HH:mm"
                          }}</span>
                        </span>
                      </div>
                      <div
                        class="d-flex align-items-center mb-1"
                        *ngIf="
                          !child?.studentClassesCourse?.confirmedClassByStudent
                        "
                      >
                        <span
                          class="badge border border-warning text-warning p-1"
                        >
                          <i class="fal fa-clock mr-1"></i> Pendente confirmação
                          do aluno
                        </span>
                      </div>

                      <!-- Confirmação do professor -->
                      <div
                        class="d-flex align-items-center mb-1"
                        *ngIf="
                          child?.studentClassesCourse?.confirmedClassByTeacher
                        "
                      >
                        <span
                          class="badge border border-success text-success p-1"
                        >
                          <i class="fal fa-check-circle mr-1"></i> Confirmado
                          pelo professor
                          <span class="badge bg-success-50 text-dark ml-1">{{
                            child?.studentClassesCourse?.confirmedDateByTeacher
                              | date: "dd/MM/yyyy HH:mm"
                          }}</span>
                        </span>
                      </div>
                      <div
                        class="d-flex align-items-center mb-1"
                        *ngIf="
                          !child?.studentClassesCourse?.confirmedClassByTeacher
                        "
                      >
                        <span
                          class="badge border border-warning text-warning p-1"
                        >
                          <i class="fal fa-clock mr-1"></i> Pendente confirmação
                          do professor
                        </span>
                      </div>

                      <!-- Justificativa -->
                      <div
                        class="alert alert-success-soft border-success fade show mb-0 mt-2 py-2 px-3"
                        role="alert"
                        *ngIf="
                          child?.studentClassesCourse
                            ?.confirmedClassByTeacher &&
                          child?.studentClassesCourse
                            ?.confirmedClassByTeacherStatusClassParams
                        "
                      >
                        <div class="d-flex align-items-center">
                          <i
                            class="fal fa-comment-check fa-lg text-success mr-2"
                          ></i>
                          <div class="flex-1">
                            <span class="fw-500 color-success-600"
                              >Confirmado com justificativa</span
                            >
                            <br />
                            <strong class="fw-700">{{
                              getStatusClassParamsStr(
                                child?.studentClassesCourse
                                  ?.confirmedClassByTeacherStatusClassParams
                              )
                            }}</strong>
                            <span
                              *ngIf="
                                child?.studentClassesCourse
                                  ?.confirmedClassByTeacherAddInfo
                              "
                            >
                              —
                              {{
                                child?.studentClassesCourse
                                  ?.confirmedClassByTeacherAddInfo
                              }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary waves-effect waves-themed"
          data-dismiss="modal"
          (click)="dismissModal()"
        >
          <i class="fal fa-times mr-1"></i> Fechar
        </button>
      </div>
    </ng-template>
  </div>
</div>
